export const makeYAxisData = (maxValue: number) => {
  const trailingLength = maxValue.toString().split('').length - 1

  const trailingZeros = trailingLength > 1 ? new Array(trailingLength - 1).fill(0).join('') : ''
  const stepSize = trailingLength >= 1 ? Number(`5${trailingZeros}`) : 1

  const steps = Math.ceil(maxValue / stepSize)
  const stepMargin = 1

  return Array.from({ length: steps + stepMargin }, (_, i) => i * stepSize)
}

export const makeStatisticsFilename = (name: string) => {
  const now = new Date()

  return `historical-statistics-${name.toLowerCase().replace(/\s+/g, '-')}-${now.toISOString()}` as const
}

export const toPercentage = (number: number) => `${Math.round(number)}%` as const
